import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export default function LeadCard({ lead, onOpen }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: lead.id,
    data: { lead }
  });
  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1
  };

  const value = Number(lead.estimatedMonthlyValueKES || 0);

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      onClick={() => onOpen?.(lead)}
      className="card p-3 cursor-grab active:cursor-grabbing hover:border-brand-500 hover:shadow-md transition"
    >
      <div className="font-semibold text-sm text-slate-800 truncate">{lead.companyName || '(no name)'}</div>
      <div className="text-xs text-slate-500 truncate">
        {lead.contactName}
        {lead.contactTitle ? `, ${lead.contactTitle}` : ''}
        {lead.industry ? ` · ${lead.industry}` : ''}
      </div>
      <div className="mt-2 flex items-center justify-between text-xs">
        <span className="chip bg-slate-100 text-slate-700">{lead.productInterest}</span>
        <span className="font-medium text-slate-700">
          {value ? `KES ${value.toLocaleString()}/mo` : '—'}
        </span>
      </div>
      {lead.ownerName && (
        <div className="mt-2 text-[11px] text-slate-500">Owner: {lead.ownerName}</div>
      )}
    </div>
  );
}
